

const PlaceHolder = () => {
    return (
        <div className="hidden  md:flex md:flex-1 ">
        </div>
    );
};

export default PlaceHolder